(function () {
  "use strict";

  if (window.__xtraQuickCartComplementaryInit) return;
  window.__xtraQuickCartComplementaryInit = true;

  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }

    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || (window.theme && window.theme.moneyFormat) || "${{amount}}";

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = typeof precision === "number" ? precision : 2;
      thousands = typeof thousands === "string" ? thousands : ".";
      decimal = typeof decimal === "string" ? decimal : ",";

      if (isNaN(number) || number == null) return "0";

      number = (number / 100.0).toFixed(precision);

      var parts = number.split(".");
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var fraction = parts[1] ? decimal + parts[1] : "";

      return whole + fraction;
    }

    switch ((formatString.match(placeholderRegex) || [null, "amount"])[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      default:
        value = formatWithDelimiters(cents, 2);
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  function getRecommendationsUrl(root) {
    var productId = root.dataset.productId;
    var maxProducts = root.dataset.maxProducts || "3";
    var sectionId = root.dataset.sectionId || "quick-cart-complementary-products";
    var baseUrl =
      (window.theme &&
        window.theme.routes &&
        window.theme.routes.productRecommendations) ||
      "/recommendations/products";

    if (!productId) return "";

    return (
      baseUrl +
      "?section_id=" +
      encodeURIComponent(sectionId) +
      "&product_id=" +
      encodeURIComponent(productId) +
      "&limit=" +
      encodeURIComponent(maxProducts) +
      "&intent=complementary"
    );
  }

  var cashbackHintsEnabled = Boolean(
    window.flu &&
      window.flu.features &&
      window.flu.features.enableCashbackHints
  );

  function hasCashbackSummary(scope) {
    var root = scope || document;

    return Boolean(
      root &&
        typeof root.querySelector === "function" &&
        root.querySelector("[data-cart-cashback-summary]")
    );
  }

  function fetchCartJson() {
    var cartBase =
      (window.theme && window.theme.routes && window.theme.routes.cart && window.theme.routes.cart.base) ||
      "/cart";

    return fetch(cartBase + ".js", {
      method: "GET",
      credentials: "include",
      headers: {
        Accept: "application/json"
      }
    }).then(function (response) {
      if (!response.ok) throw new Error("Failed to load cart");
      return response.json();
    });
  }

  function updateCashbackSummary(cartData, scope) {
    if (!cashbackHintsEnabled) return;

    var root = scope || document;

    root.querySelectorAll("[data-cart-cashback-summary]").forEach(function (summary) {
      var rate = parseFloat(summary.dataset.cashbackRate || "0");
      var amountNode = summary.querySelector("[data-cart-cashback-amount]");

      if (!amountNode || !Number.isFinite(rate) || rate <= 0 || !cartData || !cartData.total_price) {
        summary.hidden = true;
        return;
      }

      var cashbackCents = Math.round((cartData.total_price * rate) / 100);

      if (cashbackCents <= 0) {
        summary.hidden = true;
        return;
      }

      amountNode.textContent = formatMoney(cashbackCents);
      summary.hidden = false;
    });
  }

  var cashbackRefreshTimer = null;

  function scheduleCashbackRefresh(delay) {
    if (!cashbackHintsEnabled) return;

    clearTimeout(cashbackRefreshTimer);
    cashbackRefreshTimer = setTimeout(function () {
      if (!hasCashbackSummary(document)) return;

      fetchCartJson()
        .then(function (cart) {
          updateCashbackSummary(cart, document);
        })
        .catch(function () {});
    }, delay || 350);
  }

  function addItem(variantId, button) {
    var cartAdd =
      (window.theme && window.theme.routes && window.theme.routes.cart && window.theme.routes.cart.add) ||
      "/cart/add";

    if (!variantId) return;
    if (button) button.classList.add("loading");

    fetch(cartAdd + ".js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Add to cart failed");
        return response.json();
      })
      .then(function () {
        scheduleCashbackRefresh(120);
        document.dispatchEvent(new Event("apps:product-added-to-cart"));
      })
      .catch(function () {})
      .finally(function () {
        if (button) button.classList.remove("loading");
      });
  }

  function setupSlider(root) {
    var slider = root.querySelector('.cross-sells__items[data-cross-sells-slider="true"]');
    if (!slider || slider.dataset.sliderReady === "true") return;

    var track = slider.querySelector(".cross-sells__slider-inner");
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll(".cross-sells__item")) : [];
    var prev = slider.querySelector("[data-prev]");
    var next = slider.querySelector("[data-next]");

    if (!track || slides.length === 0) return;

    slider.dataset.sliderReady = "true";

    var index = 0;
    var slideWidth = 0;
    var gap = 8;
    var isDragging = false;
    var startX = 0;
    var currentX = 0;
    var baseTranslate = 0;

    function maxIndex() {
      return Math.max(0, slides.length - 1);
    }

    function getTranslateForIndex(i) {
      return -(i * (slideWidth + gap));
    }

    function setTranslate(px, animate) {
      track.style.transition = animate ? "transform 220ms ease" : "none";
      track.style.transform = "translate3d(" + px + "px, 0, 0)";
    }

    function updateButtons() {
      var atStart = index <= 0;
      var atEnd = index >= maxIndex();

      if (prev) {
        prev.classList.toggle("swiper-button-disabled", atStart);
        prev.disabled = atStart;
      }

      if (next) {
        next.classList.toggle("swiper-button-disabled", atEnd);
        next.disabled = atEnd;
      }
    }

    function goTo(nextIndex, animate) {
      if (typeof animate === "undefined") animate = true;
      index = Math.max(0, Math.min(nextIndex, maxIndex()));
      setTranslate(getTranslateForIndex(index), animate);
      updateButtons();
    }

    function layout() {
      gap = 8;

      var visibleSlides = window.innerWidth <= 719 ? 1.12 : 1.15;
      var containerWidth = slider.clientWidth;

      slideWidth = Math.floor((containerWidth - gap * (visibleSlides - 1)) / visibleSlides);

      track.style.display = "flex";
      track.style.gap = gap + "px";
      track.style.willChange = "transform";

      slides.forEach(function (slide) {
        slide.style.flex = "0 0 " + slideWidth + "px";
        slide.style.width = slideWidth + "px";
      });

      if (slides.length <= 1) {
        if (prev) prev.style.display = "none";
        if (next) next.style.display = "none";
      } else {
        if (prev) prev.style.display = "";
        if (next) next.style.display = "";
      }

      goTo(index, false);
    }

    function pointerX(evt) {
      if (evt.touches && evt.touches[0]) return evt.touches[0].clientX;
      if (evt.changedTouches && evt.changedTouches[0]) return evt.changedTouches[0].clientX;
      return evt.clientX;
    }

    function onDragStart(evt) {
      var target = evt.target;
      if (target && target.closest && target.closest("button, a, input, textarea, select, label")) return;

      isDragging = true;
      startX = pointerX(evt);
      currentX = startX;
      baseTranslate = getTranslateForIndex(index);

      slider.classList.add("is-dragging");
      setTranslate(baseTranslate, false);
    }

    function onDragMove(evt) {
      if (!isDragging) return;

      currentX = pointerX(evt);
      var delta = currentX - startX;

      var maxTranslate = 0;
      var minTranslate = getTranslateForIndex(maxIndex());

      var nextTranslate = baseTranslate + delta;
      nextTranslate = Math.min(maxTranslate + 40, Math.max(minTranslate - 40, nextTranslate));

      setTranslate(nextTranslate, false);
    }

    function onDragEnd() {
      if (!isDragging) return;

      isDragging = false;
      slider.classList.remove("is-dragging");

      var delta = currentX - startX;

      if (Math.abs(delta) > 50) {
        if (delta < 0) {
          goTo(index + 1, true);
        } else {
          goTo(index - 1, true);
        }
      } else {
        goTo(index, true);
      }
    }

    if (prev) {
      prev.addEventListener("click", function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        goTo(index - 1, true);
      });
    }

    if (next) {
      next.addEventListener("click", function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        goTo(index + 1, true);
      });
    }

    slider.addEventListener("mousedown", onDragStart);
    window.addEventListener("mousemove", onDragMove);
    window.addEventListener("mouseup", onDragEnd);

    slider.addEventListener("touchstart", onDragStart, { passive: true });
    slider.addEventListener("touchmove", onDragMove, { passive: true });
    slider.addEventListener("touchend", onDragEnd);
    slider.addEventListener("touchcancel", onDragEnd);

    layout();
    window.addEventListener("resize", layout);
  }

  function fetchComplementary(root) {
    if (!root) return;

    var productId = root.dataset.productId;
    var maxProducts = root.dataset.maxProducts || "3";
    var loadKey = productId + ":" + maxProducts;

    if (!productId) {
      root.innerHTML = "";
      return;
    }

    if (root.dataset.loadedKey === loadKey && root.innerHTML.trim() !== "") {
      return;
    }

    var url = getRecommendationsUrl(root);
    if (!url) return;

    root.dataset.loadedKey = loadKey;

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error("Failed to load recommendations");
        return response.text();
      })
      .then(function (text) {
        var html = document.createElement("div");
        html.innerHTML = text;

        var content = html.querySelector("[data-quick-cart-complementary-content]");
        root.innerHTML = content ? content.innerHTML : "";

        setupSlider(root);
      })
      .catch(function () {
        root.innerHTML = "";
      });
  }

  function initAll(scope) {
    (scope || document)
      .querySelectorAll("[data-quick-cart-complementary]")
      .forEach(fetchComplementary);
  }

  function initAddedNode(node) {
    if (!(node instanceof Element)) return;

    if (node.matches("[data-quick-cart-complementary]")) {
      fetchComplementary(node);
    }

    node.querySelectorAll("[data-quick-cart-complementary]").forEach(fetchComplementary);
  }

  function onReady() {
    initAll(document);
    scheduleCashbackRefresh(100);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onReady);
  } else {
    onReady();
  }

  document.addEventListener("apps:product-added-to-cart", function () {
    setTimeout(function () {
      initAll(document);
      scheduleCashbackRefresh(250);
    }, 250);
  });

  document.addEventListener("click", function (evt) {
    var target = evt.target;
    if (!(target instanceof Element)) return;

    var button = target.closest("[data-quick-cart-complementary] [data-add-item-id]");
    if (button) {
      evt.preventDefault();
      addItem(button.dataset.addItemId, button);
      return;
    }

    var quantityTrigger = target.closest(
      ".quick-cart [data-add-quantity], .quick-cart [data-subtract-quantity], .quick-cart [data-remove-item]"
    );

    if (quantityTrigger) {
      scheduleCashbackRefresh(450);
    }
  });

  document.addEventListener("change", function (evt) {
    var target = evt.target;
    if (target && target.matches(".quick-cart .quantity-input__input")) {
      scheduleCashbackRefresh(450);
    }
  });

  document.addEventListener("input", function (evt) {
    var target = evt.target;
    if (target && target.matches(".quick-cart .quantity-input__input")) {
      scheduleCashbackRefresh(450);
    }
  });

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(initAddedNode);
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();